/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {Icon, message} from 'antd'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import Loader from '../loaders/loader'
import queryParams from '../BaseComponent/QueryParams'

class ParcelLabel extends React.Component {
  constructor(props) {
    super(props)
    const query = new URLSearchParams(this.props.location.search)
    const queryDate = +query.get('fromTime') || null
    this.state = {
      loading: false,
      date: queryDate ? moment.unix(queryDate / 1000) : moment(),
      defaultValueDate: true,
      items: []
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }
  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  date(props) {
    return <input className="form-control" {...props} />
  }
  handleDateChange = (date) => {
    this.setState({
      date
    })
  }
  createFilter = () => {
    let filter = {}
    let {date} = this.state
    let fromOrderId = this.convertDigit(document.getElementById('fromOrderId').value.trim())
    let toOrderId = this.convertDigit(document.getElementById('toOrderId').value.trim())

    if (fromOrderId !== '') {
      filter.fromOrderId = fromOrderId
    }
    if (toOrderId !== '') {
      filter.toOrderId = toOrderId
    }
    if (date) {
      filter.fromTime = this.epochFrom(date)
      filter.toTime = this.epochTo(date)
    }
    return filter
  }
  filter() {
    if (this.state.date === null) {
      message.error('تاریخ الزامی است')
    } else {
      this.setState(() => {
        this.getReport()
      })
    }
  }
  handleChangeFromDate = (dateMin) => {
    this.setState({
      dateMin
    })
  }

  handleChangeToDate = (dateMax) => {
    this.setState({
      dateMax
    })
  }

  getReport() {
    let filter = this.createFilter()
    let createQueryFilter = filter
    this.props.history.push(`/report/parcel/print-label?${queryParams(createQueryFilter)}`)
  }
  render() {
    let {loading} = this.state
    return (
      <div className="rtl printA4Page mx-3">
        <Loader show={loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>چاپ لیبل سبد بر اساس فاکتور</li>
          </ul>
        </div>
        <div className="">
          <div className="basketFilterComponent">
            <div className="filterInputs">
              <div className="formComponent">
                <label className="font-weight-bold">
                  تاریخ :<span className="requireFiled font-weight-bold">*</span>
                </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    inline
                    okLabel="تأیید"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    cancelLabel="لغو"
                    labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                    value={this.state.date}
                    id="date"
                    onChange={this.handleDateChange}
                    TextFieldComponent={this.date}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </div>

              <div className="formComponent">
                <label>شناسه سفارش از :</label>
                <input type="text" className="form-control" id="fromOrderId" name="fromOrderId" />
              </div>

              <div className="formComponent">
                <label>شناسه سفارش تا :</label>
                <input type="text" className="form-control" id="toOrderId" name="toOrderId" />
              </div>
            </div>
            <div className="filterOption">
              {loading ? (
                <button disabled className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              ) : (
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ParcelLabel
